import React, { useEffect, useState } from "react";
import ProfileCard from "../components/ProfileCard";
import Papa from "papaparse";
import { useParams } from "react-router-dom";

const ProfilePage = () => {
  const { id } = useParams(); // React Router to get ID from URL
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const csvUrl =
      "https://docs.google.com/spreadsheets/d/1ofx7IJuWQ7NYJxyxw7rsgJEthDIL_6hcRrL5sBms4SY/export?format=csv";

    const fetchData = async () => {
      const response = await fetch(csvUrl);
      const csvText = await response.text();

      const data = [];
      Papa.parse(csvText, {
        header: true,
        complete: (results) => {
          results.data.forEach((row) => {
            data.push({
              id: row["ID"],
              name: row["Full Name"],
              designation: row["Designation"],
              semester: row["Semester"],
              austDepartment: row["Department (AUST)"],
              cdcDepartment: row["Department (CDC)"],
              email: row["E-Mail"],
              primaryPhone: row["Primary Phone Num."],
              secondaryPhone: row["Secondery Phone Num."],
              facebook: row["Facebook ID"],
              instagram: row["Instagram ID"],
              linkedin: row["LinkedIn ID"],
              portfolio: row["Portfolio or other links"],
            });
          });

          // Find the specific profile by ID
          const profileData = data.find((p) => p.id === id);
          setProfile(profileData || null);
          setLoading(false);
        },
      });
    };

    fetchData();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!profile) {
    return <div>Profile not found</div>;
  }

  return (
    <div>
      <ProfileCard
        name={profile.name}
        designation={profile.designation}
        semester={profile.semester}
        austDepartment={profile.austDepartment}
        cdcDepartment={profile.cdcDepartment}
        email={profile.email}
        primaryPhone={profile.primaryPhone}
        secondaryPhone={profile.secondaryPhone}
        facebook={profile.facebook}
        instagram={profile.instagram}
        linkedin={profile.linkedin}
        portfolio={profile.portfolio}
        image={`https://m1ql1.github.io/CDC25/images/${profile.id}.jpg`}
      />
    </div>
  );
};

export default ProfilePage;
